export const downloadAsBlob = (data, filename = 'Report.csv', mime = 'text/plain') => {
    let anchor = document.createElement('a');
    let objectUrl = window.URL.createObjectURL(new Blob([data], {type: mime}));
    anchor.href = objectUrl;
    anchor.download = filename;
    anchor.click();
    window.URL.revokeObjectURL(objectUrl);
};
